import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { Location } from '../types';
import {bindActionCreators} from 'redux';
import { NavLink } from 'react-router-dom';
import SpecialDealCard from './SpecialDealCard';
import PreBookingCard from './PreBookingCard';
import * as homeActions from '../actions/homeActions';
import * as pricingActions from '../actions/pricingActions';
import { getEndDateFromStartDateAndDurationUnit,getTimeDifference,getDatetimeFromTime,getDateString } from '../utils/dates';
import { getDurationUnits } from '../utils/durationUnits';
import { history } from '../store/configureStore';
import EditSpecialDealDetailForm from '../forms/EditSpecialDealDetailForm';

import getPortalLocData from '../config/loc';

//TODO: Remove this once we have a proper place for the images

export  class SpecialDealDetails extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      modalDetails: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(property) {
    let newState = {};
    newState[property] = !this.state[property];
    this.setState(newState);
  }




  handlerSubmit=()=>{

    let { untilDate,startDate,selectedLocation,selectedOffering}=this.props.locationDetail;

    if(!untilDate){
      this.props.homeActions.updateBookingToDate(getEndDateFromStartDateAndDurationUnit(startDate,1,getDurationUnits(3)).toISOString());
    }
    if(selectedOffering.type!=0){
      this.props.homeActions.updateBookingToDate(getEndDateFromStartDateAndDurationUnit(startDate,1,getDurationUnits(3)).toISOString());
    }
    let findService=selectedLocation.offerings.filter(s=>s.type==0)[0];
    this.props.homeActions.setSelectedOffer(findService);
    this.props.pricingActions.SelectPricingModel(this.props.pricing.defaultPricingModel);

    this.notRouter("/bookingdetail");

  }
  handleSpecialDealSubmit=()=>{

    this.props.pricingActions.SelectPricingModel(this.props.pricing.dealPricingModel);
    this.notRouter("/bookingdetail");
  }

  notRouter ( link ) {
    window.scrollTo(0, 0);
    history.push(link); 
  }

  handlerPriceChange(){
    let { startDate,selectedLocationId,untilDate} = this.props.locationDetail;
    let reqeust={
      locationId:selectedLocationId,
      startTime:startDate,
      duration:untilDate?getTimeDifference(startDate,untilDate):1,
      durationUnit:3,
      TariffGroupId: getPortalLocData().tarrifID,
      smsReminder:false,
      optionalServices:[]
    };
    this.props.pricingActions.getPrice(reqeust);
  }

  handleDealDetail(deal){
    let { selectedLocation } = this.props.locationDetail;
    this.props.homeActions.setSelectedOffer(deal).then(()=>{
      let {selectedOffering}=this.props.locationDetail;
      this.props.homeActions.updateBookingFromDate(getDatetimeFromTime(selectedOffering.minimumStartTime));
     
      this.props.homeActions.calculateOfferPricing(selectedLocation.location.id,deal.id);
      let toDate=getEndDateFromStartDateAndDurationUnit(getDatetimeFromTime(selectedOffering.minimumStartTime),this.props.locationDetail.selectedOffering.pricing.duration,getDurationUnits(this.props.locationDetail.selectedOffering.pricing.durationUnits));
      this.props.homeActions.updateBookingToDate(toDate);
      this.props.homeActions.checkSpaceAvailable(getDateString(getDatetimeFromTime(selectedOffering.minimumStartTime)));
      this.toggle("modalDetails");
    });

 
  }

  render(){
    let {selectedLocation,isFetching,startDate,untilDate,untilDateChanged}=this.props.locationDetail;
    let {isLoading}=this.props.pricing;
    return (
      <div>

          {/* {
            selectedLocation && selectedLocation.location?
            selectedLocation.offerings.map((deal, index) =>{
              if(deal.type==0){
                return (<div className="card br" key={index}>
                  <div className="card-body p-0">
                    <PreBookingCard
                      isLoading={isLoading}
                      handleFromTimeChange={this.handlerFromTimeChange}
                      handleToTimeChange={this.handlerToTimeChange}
                      onSubmit={this.handlerSubmit}
                      locationId={selectedLocation.location.id}
                      minimumDuration={deal.pricing.minimumDuration}
                      maximumDuration={deal.pricing.maximumDuration}
                      durationUnits={deal.pricing.durationUnits?deal.pricing.durationUnits:3}

                      startTime={startDate}
                      untilTime={untilDateChanged?untilDate:getEndDateFromStartDateAndDurationUnit(startDate,1,getDurationUnits(deal.pricing.durationUnits?deal.pricing.durationUnits:3)).toISOString()}
                      
                      offeringId={deal.id}
                      disabled={deal.type!=0} 
                    />
                  </div>
                </div>);
              }
            }):null
          } */}

          <div className="card">
            <div className="card-body">
              <div className="card-title">
                <h3 className="card-title">Special Deals</h3>
              </div>
              {
                selectedLocation && selectedLocation.location?
                  
                  selectedLocation.offerings.map((deal, index) =>{
                    if(deal.type > 0){
                      return <SpecialDealCard deal={deal} key={index} isLoading={isFetching} handleDealDetail={()=>this.handleDealDetail(deal)}/>;
                  }
                } ):null
              }
            </div>
          </div>
      

{ isFetching ? 
  <div id="overlay">
    <div className="loader">
      Loading...
    </div>
  </div> : null }
  <div id="modelform">
    {
      selectedLocation && selectedLocation.location? 
        <EditSpecialDealDetailForm 
          isOpen={this.state.modalDetails} 
          toggle={()=>this.toggle("modalDetails")}
          onSubmit={this.handleSpecialDealSubmit}/>:null
    }
  </div>
</div>
);


  }




}




SpecialDealDetails.propTypes = {
 
  locationDetail: PropTypes.object,
  homeActions:PropTypes.object.isRequired,
  pricingActions:PropTypes.object.isRequired,
  pricing:PropTypes.object


};
function mapStateToProps(state) {
  return {
    locationDetail: state.locationDetail,
    pricing:state.pricing
  };
}

function mapDispatchToProps(dispatch) {
  return {
    homeActions: bindActionCreators(homeActions, dispatch),
    pricingActions: bindActionCreators(pricingActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialDealDetails);


// WEBPACK FOOTER //
// ./src/components/SpecialDealDetails.jsx